var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-ellipsis"},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }